var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailFilled = function SvgEmailFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.485 4.8h16.028c1.512 0 2.274.708 2.274 2.148v10.104c0 1.428-.761 2.148-2.274 2.148H5.485c-1.512 0-2.274-.72-2.274-2.148V6.948c0-1.44.762-2.148 2.274-2.148Zm8.008 10.32 8.153-6.636c.29-.24.52-.792.158-1.284-.351-.492-.992-.504-1.416-.204l-6.895 4.632L6.61 6.996c-.423-.3-1.064-.288-1.415.204-.363.492-.133 1.044.157 1.284l8.141 6.636Z",
    fill: "#fff"
  })));
};
export default SvgEmailFilled;